import {gql} from '@apollo/client'

export const GET_ALL_USERS_BASIC = gql`
  query allUsers(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $name: String
    $email: String
    $groupAssignment: String
    $isActive: Boolean
    $organization: String
  ) {
    allUsers(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      name: $name
      email: $email
      groupAssignment: $groupAssignment
      isActive: $isActive
      organization: $organization
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          firstName
          lastName
          email
          cellphone
          isActive
          npn
          primaryGroup {
            id
            name
          }
        }
      }
    }
  }
`
export const GET_ALL_USERS_INFO = gql`
  query allUsers(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $name: String
    $email: String
    $groupAssignment: String
    $role: String
    $isActive: Boolean
    $organization: String
  ) {
    allUsers(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      name: $name
      email: $email
      groupAssignment: $groupAssignment
      role: $role
      isActive: $isActive
      organization: $organization
    ) {
      totalCount
      totalCountDisable
      totalCountEnable
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          firstName
          lastName
          email
          cellphone
          avatar
          primaryGroup {
            id
            name
          }
          organization {
            id
            name
            logo
            templateLogo
            website
            country
          }
          organizationTemplateLogo
          isActive
          applyDeductions
          npn
          groupAssignmentSet {
            edges {
              node {
                id
                name
              }
            }
          }
          allowedChannels
        }
      }
    }
  }
`
export const GET_ONE_MEMBER_USER = gql`
  query allUsers(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
  ) {
    allUsers(offset: $offset, before: $before, after: $after, first: $first, last: $last, id: $id) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          firstName
          lastName
          email
          cellphone
          avatar
          isActive
          applyDeductions
          npn
          organization {
            id
            name
            logo
            templateLogo
            website
            country
          }
          organizationTemplateLogo
          primaryGroup {
            id
            name
          }
          groupAssignmentSet {
            edges {
              node {
                id
                name
              }
            }
          }
          allowedChannels
        }
      }
    }
  }
`

export const GET_USER_BY_ID = gql`
  query userById($id: String!) {
    userById(id: $id) {
      id
      firstName
      lastName
      email
      cellphone
      avatar
      isActive
      applyDeductions
      npn
      primaryGroup {
        id
        name
      }
      organization {
        id
        name
        logo
        templateLogo
        website
        country
      }
      organizationTemplateLogo
      groupAssignmentSet {
        edges {
          node {
            id
            name
          }
        }
      }
      allowedChannels
    }
  }
`

export const GET_ALL_USERS_LIST = gql`
  query allUsersList {
    allUsersList {
      id
      firstName
      lastName
      npn
      email
      primaryGroup {
        id
        name
      }
    }
  }
`

export const GET_ALL_USERS_FILTER = gql`
  query allUsers($name: String, $requireNpn: Boolean) {
    allUsers(name: $name, requireNpn: $requireNpn) {
      edges {
        node {
          id
          firstName
          lastName
          npn
          email
        }
      }
    }
  }
`

export const GET_ALL_USER_DEDUCTIONS = gql`
  query allCommissionDeductionUser(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $user_Id: Float
    $deductionType_Id: Float
  ) {
    allCommissionDeductionUser(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      user_Id: $user_Id
      deductionType_Id: $deductionType_Id
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          value
          deductionType {
            id
            name
            deductionType
          }
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`
